// @flow
const routes = require('next-routes-with-locale')({ locale: 'en' });

const {
  HOW_IT_WORKS,
  FINDER_FACILITY,
  DETAILS_FACILITY,
  DETAILS_COMPANY,
  BLOG,
  BLOG_ARTICLE,
  BLOG_CATEGORY,
  COMPANY_TERMS,
  COMPANY_DATA_PROCESSING,
  COMPANY_DATA_PROTECTION,
  COMPANY_IMPRESSUM,
  COMPANY_FOR_HOSPITALS,
  PROFILE_LOGIN,
  FAQS,
  FAQS_CATEGORY,
  FAQS_QUESTION,
  PROFILE,
  PROFILE_SUB_TAB,
  PROFILE_SUB_TAB_ANCHOR,
  PROFILE_SETTINGS,
  RECOMMENDATIONS,
  DASHBOARD,
  INDEX,
  FORGOT_PASSWORD_SET,
  CONTACT_US,
  FINDER_TREATMENT,
  DETAILS_TREATMENT,
  FINDER_DOCTOR,
  FINDER_PACKAGE,
  DETAILS_DOCTOR,
  ABOUT_US,
  ONLINE_CONSULTATION,
  DETAILS_PACKAGE,
  PACKAGE_PAYMENT,
  PROFILE_PACKAGE_FORM,
  COST_FLOW,
  SECOND_OPINION_FLOW,
  ONLINE_CONSULTATION_FLOW,
  OPINION_PATIENT_FLOW,
  OPINION_MAIN_FLOW,
  CONSULTATION_PATIENT_FLOW,
  CONSULTATION_MAIN_FLOW,
  SECOND_OPINION_PAYMENT,
  ONLINE_CONSULTATION_PAYMENT,
  PAYMENT_SUCCESS,
  SECOND_OPINION,
  SECOND_OPINION_BLOOD_CANCER,
  COST_CALCULATOR,
  SECOND_OPINION_NEUROLOGY,
  TREATMENT_COST_FLOW,
  TREATMENT_PLAN_PATIENT_FLOW,
  SITEMAP,
  COMPANY_REFUND,
  TREATMENT_FILTER,
  FACILITY_FILTER,
  PACKAGE_FILTER,
  DOCTOR_FILTER
} = require('./nextRouteNames');

routes
  .add(INDEX, 'en', '/', 'index')
  .add(INDEX, 'ar', '/', 'index')

  .add(BLOG, 'en', '/blog', 'blog')
  .add(BLOG, 'ar', '/blog', 'blog')

  .add(BLOG_ARTICLE, 'en', '/blog/articles/:slug', 'blog/article')
  .add(BLOG_ARTICLE, 'ar', '/blog/articles/:slug', 'blog/article')

  .add(BLOG_CATEGORY, 'en', '/blog/categories/:slug/:id', 'blog/category')
  .add(BLOG_CATEGORY, 'ar', '/blog/categories/:slug/:id', 'blog/category')

  .add(HOW_IT_WORKS, 'en', '/how-it-works', 'howItWorks')
  .add(HOW_IT_WORKS, 'ar', '/how-it-works', 'howItWorks')

  .add(FINDER_FACILITY, 'en', '/facility', 'finder/facility')
  .add(FINDER_FACILITY, 'ar', '/facility', 'finder/facility')

  .add(FACILITY_FILTER, 'en', '/hospitals/:departments/:address_city', 'finder/facility')
  .add(FACILITY_FILTER, 'ar', '/hospitals/:departments/:address_city', 'finder/facility')

  .add(FINDER_TREATMENT, 'en', '/treatments', 'finder/treatment')
  .add(FINDER_TREATMENT, 'ar', '/treatments', 'finder/treatment')

  .add(TREATMENT_FILTER, 'en', '/treatment-list/:department', 'finder/treatment')
  .add(TREATMENT_FILTER, 'ar', '/treatment-list/:department', 'finder/treatment')

  .add(FINDER_PACKAGE, 'en', '/packages', 'finder/package')
  .add(FINDER_PACKAGE, 'ar', '/packages', 'finder/package')

  .add(PACKAGE_FILTER, 'en', '/package-list/:country', 'finder/package')
  .add(PACKAGE_FILTER, 'ar', '/package-list/:country', 'finder/package')

  .add(DETAILS_TREATMENT, 'en', '/treatments/:slug', 'details/treatment')
  .add(DETAILS_TREATMENT, 'ar', '/treatments/:slug', 'details/treatment')

  .add(FINDER_DOCTOR, 'en', '/doctors', 'finder/doctor')
  .add(FINDER_DOCTOR, 'ar', '/doctors', 'finder/doctor')

  .add(DOCTOR_FILTER, 'en', '/doctors/:department/:address_city', 'finder/doctor')
  .add(DOCTOR_FILTER, 'ar', '/doctors/:department/:address_city', 'finder/doctor')

  .add(DETAILS_DOCTOR, 'en', '/doctors/:slug', 'details/doctor')
  .add(DETAILS_DOCTOR, 'ar', '/doctors/:slug', 'details/doctor')

  .add(DETAILS_FACILITY, 'en', '/facility/:slug', 'details/facility')
  .add(DETAILS_FACILITY, 'ar', '/facility/:slug', 'details/facility')

  .add(DETAILS_COMPANY, 'en', '/clinics/:slug', 'details/company')
  .add(DETAILS_COMPANY, 'ar', '/clinics/:slug', 'details/company')

  .add(DETAILS_PACKAGE, 'en', '/packages/:slug', 'details/package')
  .add(DETAILS_PACKAGE, 'ar', '/packages/:slug', 'details/package')

  .add(PROFILE_PACKAGE_FORM, 'en', '/profile-package-form/:slug', 'profilePackageForm')
  .add(PROFILE_PACKAGE_FORM, 'ar', '/profile-package-form/:slug', 'profilePackageForm')

  .add(PACKAGE_PAYMENT, 'en', '/package-payment/:slug/:patientId', 'packagePayment')
  .add(PACKAGE_PAYMENT, 'ar', '/package-payment/:slug/:patientId', 'packagePayment')

  .add(PAYMENT_SUCCESS, 'en', '/payment-success/:slug/:patientId', 'paymentSuccess')
  .add(PAYMENT_SUCCESS, 'ar', '/payment-success/:slug/:patientId', 'paymentSuccess')

  .add(COMPANY_TERMS, 'en', '/terms-and-conditions', 'company/terms')
  .add(COMPANY_TERMS, 'ar', '/terms-and-conditions', 'company/terms')

  .add(COMPANY_REFUND, 'en', '/refund-policy', 'company/refund')
  .add(COMPANY_REFUND, 'ar', '/refund-policy', 'company/refund')

  .add(COMPANY_DATA_PROCESSING, 'en', '/data-processing', 'company/dataProcessing')
  .add(COMPANY_DATA_PROCESSING, 'ar', '/data-processing', 'company/dataProcessing')

  .add(COMPANY_DATA_PROTECTION, 'en', '/privacy', 'company/dataProtection')
  .add(COMPANY_DATA_PROTECTION, 'ar', '/privacy', 'company/dataProtection')

  .add(COMPANY_IMPRESSUM, 'en', '/imprint', 'company/impressum')
  .add(COMPANY_IMPRESSUM, 'ar', '/imprint', 'company/impressum')

  .add(COMPANY_FOR_HOSPITALS, 'en', '/for-hospitals', 'company/for-hospitals')
  .add(COMPANY_FOR_HOSPITALS, 'ar', '/for-hospitals', 'company/for-hospitals')

// .add(SIGN_IN, 'en', '/login', 'signIn')
// .add(SIGN_IN, 'ar', '/login', 'signIn')

  .add(PROFILE_LOGIN, 'en', '/profile-login', 'profileLogin')
  .add(PROFILE_LOGIN, 'ar', '/profile-login', 'profileLogin')

  .add(RECOMMENDATIONS, 'en', '/recommendations', 'recommendations')
  .add(RECOMMENDATIONS, 'ar', '/recommendations', 'recommendations')

  .add(FAQS, 'en', '/faqs', 'faqs')
  .add(FAQS, 'ar', '/faqs', 'faqs')

  .add(FAQS_CATEGORY, 'en', '/faqs/categories/:slug', 'faqs/categories')
  .add(FAQS_CATEGORY, 'ar', '/faqs/categories/:slug', 'faqs/categories')

  .add(
    FORGOT_PASSWORD_SET,
    'en',
    '/patient/account/verify/:patientEmail/:token',
    'forgotPasswordSet'
  )
  .add(
    FORGOT_PASSWORD_SET,
    'ar',
    '/patient/account/verify/:patientEmail/:token',
    'forgotPasswordSet'
  )

  .add(
    FAQS_QUESTION,
    'en',
    '/faqs/categories/:categorySlug/questions/:questionSlug',
    'faqs/questions'
  )
  .add(
    FAQS_QUESTION,
    'ar',
    '/faqs/categories/:categorySlug/questions/:questionSlug',
    'faqs/questions'
  )

  .add(PROFILE_SETTINGS, 'en', '/profile/settings', 'profile/settings')
  .add(PROFILE_SETTINGS, 'ar', '/profile/settings', 'profile/settings')

  .add(PROFILE, 'en', '/profile/:primaryTab', 'profile')
  .add(PROFILE, 'ar', '/profile/:primaryTab', 'profile')

  .add(PROFILE_SUB_TAB_ANCHOR, 'en', '/profile/:primaryTab/:secondaryTab/#:anchor', 'profile')
  .add(PROFILE_SUB_TAB_ANCHOR, 'ar', '/profile/:primaryTab/:secondaryTab/#:anchor', 'profile')

  .add(PROFILE_SUB_TAB, 'en', '/profile/:primaryTab/:secondaryTab', 'profile')
  .add(PROFILE_SUB_TAB, 'ar', '/profile/:primaryTab/:secondaryTab', 'profile')

  .add(DASHBOARD, 'en', '/dashboard', 'dashboard')
  .add(DASHBOARD, 'ar', '/dashboard', 'dashboard')

  .add(CONTACT_US, 'en', '/contact-us', 'contactUs')
  .add(CONTACT_US, 'ar', '/contact-us', 'contactUs')

  .add(ONLINE_CONSULTATION, 'en', '/online-consultation', 'onlineConsultation')
  .add(ONLINE_CONSULTATION, 'ar', '/online-consultation', 'onlineConsultation')

  .add(OPINION_MAIN_FLOW, 'en', '/opinion-flow/:path?', 'opinionMainFlow')
  .add(OPINION_MAIN_FLOW, 'ar', '/opinion-flow/:path?', 'opinionMainFlow')

  .add(OPINION_PATIENT_FLOW, 'en', '/opinion-patient-flow/:patientId/:department/:path', 'opinionPatientFlow')
  .add(OPINION_PATIENT_FLOW, 'ar', '/opinion-patient-flow/:patientId/:department/:path', 'opinionPatientFlow')

  .add(CONSULTATION_MAIN_FLOW, 'en', '/consultation-flow/:path?', 'consultationMainFlow')
  .add(CONSULTATION_MAIN_FLOW, 'ar', '/consultation-flow/:path?', 'consultationMainFlow')

  .add(CONSULTATION_PATIENT_FLOW, 'en', '/consultation-patient-flow/:patientId/:department/:path', 'consultationPatientFlow')
  .add(CONSULTATION_PATIENT_FLOW, 'ar', '/consultation-patient-flow/:patientId/:department/:path', 'consultationPatientFlow')

  .add(TREATMENT_COST_FLOW, 'en', '/treatment-cost-flow/:path', 'treatmentCostFlow')
  .add(TREATMENT_COST_FLOW, 'ar', '/treatment-cost-flow/:path', 'treatmentCostFlow')

  .add(TREATMENT_PLAN_PATIENT_FLOW, 'en', '/treatment-plan-flow/:patientId/:path', 'treatmentPlanPatientFlow')
  .add(TREATMENT_PLAN_PATIENT_FLOW, 'ar', '/treatment-plan-flow/:patientId/:path', 'treatmentPlanPatientFlow')

  .add(COST_FLOW, 'en', '/cost-calculator', 'costFlow')
  .add(COST_FLOW, 'ar', '/cost-calculator', 'costFlow')

  .add(SECOND_OPINION_FLOW, 'en', '/second-opinion', 'secondOpinionFlow')
  .add(SECOND_OPINION_FLOW, 'ar', '/second-opinion', 'secondOpinionFlow')

  .add(SECOND_OPINION_PAYMENT, 'en', '/booking-payment/second-opinion/:patientId', 'secondOpinionPayment')
  .add(SECOND_OPINION_PAYMENT, 'ar', '/booking-payment/second-opinion/:patientId', 'secondOpinionPayment')

  .add(ONLINE_CONSULTATION_PAYMENT, 'en', '/booking-payment/online-consultation/:patientId', 'onlineConsultationPayment')
  .add(ONLINE_CONSULTATION_PAYMENT, 'ar', '/booking-payment/online-consultation/:patientId', 'onlineConsultationPayment')

  .add(ONLINE_CONSULTATION_FLOW, 'en', '/book-online-consultation', 'onlineConsultationFlow')
  .add(ONLINE_CONSULTATION_FLOW, 'ar', '/book-online-consultation', 'onlineConsultationFlow')

  .add(ABOUT_US, 'en', '/about-us', 'aboutUs')
  .add(ABOUT_US, 'ar', '/about-us', 'aboutUs')

  .add(SECOND_OPINION, 'en', '/book-second-opinion', 'secondOpinion')
  .add(SECOND_OPINION, 'ar', '/book-second-opinion', 'secondOpinion')

  .add(SECOND_OPINION_BLOOD_CANCER, 'ar', '/book-second-opinion-blood-cancer', 'secondOpinionBloodCancer')
  .add(SECOND_OPINION_BLOOD_CANCER, 'en', '/book-second-opinion-blood-cancer', 'secondOpinionBloodCancer')

  .add(COST_CALCULATOR, 'ar', '/estimate-treatment-cost', 'costCalculator')
  .add(COST_CALCULATOR, 'en', '/estimate-treatment-cost', 'costCalculator')

  .add(SECOND_OPINION_NEUROLOGY, 'en', '/book-second-opinion-neurology', 'secondOpinionNeurology')
  .add(SECOND_OPINION_NEUROLOGY, 'ar', '/book-second-opinion-neurology', 'secondOpinionNeurology')

  .add(SITEMAP, 'ar', '/sitemap.html', 'sitemap')
  .add(SITEMAP, 'en', '/sitemap.html', 'sitemap');

module.exports = { routes };
